module.exports = __webpack_public_path__ + "static/media/ZonaPro-Black.53247969.woff";